import { createFileRoute } from '@tanstack/react-router'
import { ProductPageView } from '@src/components/ProductPageView'
import { useFormSettings } from '@src/components/LeadForm/useFormSettings'
import { loadProductPage } from '@src/utils/loadProductPage'
import { routePageHead } from '@src/utils/routeHead'
import type { TechnologyPageData } from '@src/types/strapi'

export const Route = createFileRoute('/products/$slug')({
  loader: ({ params }) => loadProductPage(params.slug),
  staleTime: 60_000,
  head: ({ loaderData }) =>
    routePageHead(
      loaderData?.pageData?.seo?.pageTitle,
      loaderData?.pageData?.seo?.noIndex,
    ),
  component: ProductPage,
})

function ProductPage() {
  const formSettings = useFormSettings()
  const { pageData } = Route.useLoaderData() as {
    pageData: TechnologyPageData
  }

  return (
    <ProductPageView
      pageData={pageData}
      defaultLeadForm={formSettings?.productEnquiry}
    />
  )
}
